import { Component, Input } from '@angular/core';

@Component({
  selector: 'ubs-order-payments',
  templateUrl: './order-payments.component.html',
  styleUrls: ['./order-payments.component.scss']
})
export class OrderPaymentsComponent {
  @Input() orderId:string;
}
